import {
  ObtenerClasificaciones,
  ObtenerClasificacionPorCabecera,
  Cargando,
  Error,
} from "./../Types/Clasificacion.type";
import { firebaseFS } from "../Firebase/FirebaseApp";
import { dispatchController } from "./index.actions";
import { __Colecciones } from "./../environment";

export const obtenerClasificaciones = () => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    let clasificaciones = [];
    const respuesta = await firebaseFS.collection(__Colecciones.Clasificacion);
    await respuesta.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        clasificaciones = [
          ...clasificaciones,
          {
            id: doc.id,
            datos: doc.data(),
          },
        ];
      });
    });

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: clasificaciones,
    };

    dispatchController(ObtenerClasificaciones, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const obtenerClasificacionPorCabecera = (cabecera) => async (
  dispatch
) => {
  try {
    dispatch({
      type: Cargando,
    });

    let clasificaciones = [];
    const respuesta = await firebaseFS
      .collection(__Colecciones.Clasificacion)
      .where("Cabecera", "==", cabecera);
    await respuesta.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        clasificaciones = [
          ...clasificaciones,
          {
            id: doc.id,
            datos: doc.data(),
          },
        ];
      });
    });

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: clasificaciones,
    };

    dispatchController(
      ObtenerClasificacionPorCabecera,
      Error,
      dispatch,
      bodyJson
    );
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};
